import {
  ChangeDetectorRef, ComponentRef,
  Directive, Host, HostBinding, HostListener,
  Input,
  OnInit, Optional, SkipSelf,
  TemplateRef, ViewContainerRef
} from '@angular/core';
import { FormFieldComponent } from '../components/form-field.component';

@Directive({
  selector: '[formControl]'
})
export class FormControlDirective implements OnInit {
  
  /**
   * @description
   * The parent  for the containers
   *
   * @internal
   */
  
  _parent: FormFieldComponent;
  
  // @HostBinding('value') get value() {
  //   return this._parent.control.value;
  // }
  
  constructor(
    private cd: ChangeDetectorRef,
    private _vcRef: ViewContainerRef,
    @Optional() @Host() @SkipSelf() parent: FormFieldComponent
  ) {
    this._parent = parent;
    
  }
  
  ngOnInit(): void {
    this._vcRef["_data"].componentView.component.value = this._parent.control.value;
    this._vcRef["_data"].componentView.component.cd.detectChanges()
  }
  
  @HostListener('change', ['$event'])
  onChanged = e => {
    if (e instanceof Event) {
      // e.stopPropagation()
    } else {
      this._parent.control.setValue(e);
      this.cd.markForCheck();
    }
  };
  
  @HostListener('blur', ['$event'])
  onBlurred = (e) => {
    this._parent.control.markAsBlurred();
    if (!this._parent.control.touched) {
      this._parent.control.markAsTouched();
    }
    
    this.cd.markForCheck();
  };
  
}
